import { createTheme } from '@mui/material/styles';
export const darkBg = 'rgb(20, 20, 20)';
export const darkTxt = 'rgb(230, 230, 230)';
export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: 'rgb(128, 128, 128)',
      contrastText: 'rgb(50, 50, 50)',
    },
    secondary: {
      main: 'rgb(150, 150, 150)',
      contrastText: 'rgb(80, 80, 80)',
    },
    tertiary: {
      main: 'rgb(180, 180, 180)',
      contrastText: 'rgb(30, 30, 30)',
    },
    error: {
      main: 'rgb(200, 200, 200)',
      contrastText: 'rgb(100, 100, 100)',
    },
    background: {
      default: 'rgb(20, 20, 20)',
      paper: 'rgb(20, 20, 20)',
    },
    surface: {
      main: 'rgb(20, 20, 20)',
      variant: 'rgb(60, 60, 60)',
      dim: 'rgb(40, 40, 40)',
      bright: 'rgb(80, 80, 80)',
      container: 'rgb(30, 30, 30)',
      containerLow: 'rgb(35, 35, 35)',
      containerHigh: 'rgb(25, 25, 25)',
    },
    text: {
      primary: 'rgb(230, 230, 230)',
      secondary: 'rgb(200, 200, 200)',
      disabled: 'rgb(150, 150, 150)',
      hint: 'rgb(200, 200, 200)',
    },
  },
  typography: {
    fontFamily: 'Comfortaa, sans-serif',
  },
  overrides: {
    MuiButton: {
      // Add button overrides if needed
    },
    // Add more overrides as needed
  },
});

// Light theme grayscale colors
export const lightBg = 'rgb(240, 240, 240)';
export const lightTxt = 'rgb(30, 30, 30)';
export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: 'rgb(100, 100, 100)',
      contrastText: 'rgb(250, 250, 250)',
    },
    secondary: {
      main: 'rgb(150, 150, 150)',
      contrastText: 'rgb(250, 250, 250)',
    },
    tertiary: {
      main: 'rgb(180, 180, 180)',
      contrastText: 'rgb(250, 250, 250)',
    },
    error: {
      main: 'rgb(200, 200, 200)',
      contrastText: 'rgb(250, 250, 250)',
    },
    background: {
      default: 'rgb(240, 240, 240)',
      paper: 'rgb(240, 240, 240)',
    },
    surface: {
      main: 'rgb(240, 240, 240)',
      variant: 'rgb(200, 200, 200)',
      dim: 'rgb(220, 220, 220)',
      bright: 'rgb(250, 250, 250)',
      container: 'rgb(230, 230, 230)',
      containerLow: 'rgb(235, 235, 235)',
      containerHigh: 'rgb(225, 225, 225)',
    },
    text: {
      primary: 'rgb(30, 30, 30)',
      secondary: 'rgb(60, 60, 60)',
      disabled: 'rgb(120, 120, 120)',
      hint: 'rgb(180, 180, 180)',
    },
  },
  typography: {
    fontFamily: 'Comfortaa, sans-serif',
  },
  overrides: {
    MuiButton: {
      // Add button overrides if needed
    },
    // Add more overrides as needed
  },
});